import { camelCase, capitalize, upperFirst, words } from 'lodash';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { Value } from 'core/types';

// Gets the value of a nested or not property from an object
export const getValue = <T>(object: T, path: string, placeholder = DEFAULT_PLACEHOLDER): Value => {
  const keys = path.split('.');

  let value = object;
  for (const key of keys) {
    value = value?.[key];

    if (value === undefined || value === null) {
      return placeholder;
    }
  }

  if (value && Number(value) === 0) {
    return 0;
  }

  return (value || placeholder) as Value;
};

export const getLabel = (value?: string, { capitalizeAllWords = true } = {}): string => {
  return (
    words(value)
      .map((word, index) => {
        return index === 0 || capitalizeAllWords ? capitalize(word) : word;
      })
      .join(' ') || undefined
  );
};

export const getTranslationKey = (prefix: string, value: string): string =>
  `${prefix}${upperFirst(camelCase(value))}`;
